import React from "react";

const cleanContent = (content) => {
    return content;
};

const BlogInsert = (props) => {
    let bgColor = props.bgcolor ? props.bgcolor : "white";
    let content=props.content?.content ? props.content.content : "";
    let fontSize = props.fontSize ? props.fontSize : "14pt";
    //let height=props.height ? props.height : "100%";
    return <div
        className="blogInsert"
        style={{fontSize:fontSize,padding:"16px",background:bgColor, width:"100%"}}
        dangerouslySetInnerHTML={{__html:cleanContent(content)}}
    />
};

export default BlogInsert;
